module.exports = __webpack_public_path__ + "static/img/loginUserBg.a9cc7af8.png";